import React from "react";
import { Field } from "react-final-form";
import { isRequired } from "@lib/validations";

import InputCheckbox from "@components/Form/Checkbox";

const CheckboxInput = (props) => {
  if (props.valid) {
    return (
      <Field
        id={props.name}
        name={props.name}
        component={InputCheckbox}
        label={props.label}
        type="checkbox"
        required={props.required}
        validate={
          props.required
            ? isRequired()
            : () => {
                return undefined;
              }
        }
      />
    );
  }

  // Invalid component
  return null;
};

export default CheckboxInput;
